var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 12.75V21C20 21.55 19.55 22 19 22H3C2.45 22 2 21.55 2 21V5C2 4.45 2.45 4 3 4H11.23L13.25 2H3C1.35 2 0 3.35 0 5V21C0 22.65 1.35 24 3 24H19C20.65 24 22 22.65 22 21V10.75L20 12.75Z",
    fill: "#0F0F0F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.82 1C17.7 1 16.65 1.43 15.87 2.22L5.21 12.79C5.06 12.93 4.97 13.12 4.93 13.32L3.93 18.82C3.87 19.14 3.97 19.47 4.21 19.71C4.4 19.9 4.65 20 4.92 20C4.98 20 5.04 20 5.1 19.98L10.68 18.98C10.88 18.94 11.07 18.85 11.21 18.7L21.79 8.13C22.57 7.34 23 6.29 23 5.18C23 2.87 21.12 1 18.82 1ZM10.01 17.07L6.15 17.76L6.84 13.99L14.48 6.4L17.58 9.5L10.01 17.07ZM20.37 6.72L19 8.09L15.91 5L17.28 3.64C17.69 3.23 18.24 3 18.82 3C20.02 3 21 3.98 21 5.19C21 5.77 20.77 6.32 20.37 6.73V6.72Z",
    fill: "#0F0F0F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/EditIcon.29c5dd2c.svg";
export { ForwardRef as ReactComponent };